<sc-dialog-title>{{'clean transport' | translate: ['tmc-yard.clean-transport.title',
    translationService.language]}}</sc-dialog-title>
<sc-padding>
    <form [formGroup]="optionsFormGroup">
        <mat-radio-group formControlName="cleanupAction">
            <div>
                <mat-radio-button [disabled]="!archiveTransportEnabled" value="archiveTransport">{{'archive transport'
                    |translate:
                    ['tmc-yard.clean-transport.option.archive-transport',translationService.language]}}</mat-radio-button>
            </div>
            <div>
                <mat-radio-button [disabled]="!assignVehicleToStationEnabled" value="assignVehicleToStation">{{'assign to station' |
                    translate:['tmc-yard.clean-transport.option.assign-vehicle-to-station',translationService.language]}}</mat-radio-button>
                <ng-container *ngIf="assignVehicleToStationVisible">
                    <sc-flex [stretchContent]="true">
                        <mat-form-field>
                            <input matInput formControlName="vehicleTargetStationName" name="vehicleTargetStationName"
                                placeholder="{{'target station' | translate: ['tmc-yard.clean-transport.option.assign-vehicle-to-station.target-station', translationService.language]}}"
                                [required]="true" [readonly]="true">
                        </mat-form-field>
                        <button mat-icon-button type="button" (click)="assignVehicleTargetStation()"
                            class="small-button assign-button"><sc-icon iconClass="fa-sitemap"></sc-icon></button>
                    </sc-flex>
                </ng-container>
            </div>
        </mat-radio-group>
    </form>
</sc-padding>
<app-service-response [responseMessages]="responseMessages"></app-service-response>
<sc-padding>
    <sc-flex>
        <sc-content-spacer [grow]="true"></sc-content-spacer>
        <button mat-stroked-button (click)="cancel()">{{'cancel' | translate: ['tmc-yard.action.dialog.cancel',
            translationService.language]}}</button>
        <sc-content-spacer></sc-content-spacer>
        <button mat-flat-button [disabled]="!confirmEnabled" (click)="confirm()">{{'confirm' | translate:
            ['tmc-yard.action.dialog.confirm',
            translationService.language]}}</button>
    </sc-flex>
</sc-padding>